// Accordion behavior for the FAQ. Clicking a `.faq-toggle` opens its answer
// (`.open`) and rotates the chevron (`.rotated`), closing any other open item.
export default function initFaq() {
  const toggles = document.querySelectorAll(".faq-toggle")
  if (!toggles.length) return

  toggles.forEach((button) => {
    button.addEventListener("click", () => {
      const item = button.closest(".faq-item")
      if (!item) return
      const answer = item.querySelector(".faq-answer")
      const chevron = item.querySelector(".faq-chevron")
      const isOpen = answer.classList.contains("open")

      // Close all.
      document
        .querySelectorAll(".faq-answer.open")
        .forEach((a) => a.classList.remove("open"))
      document
        .querySelectorAll(".faq-chevron.rotated")
        .forEach((c) => c.classList.remove("rotated"))
      document
        .querySelectorAll('.faq-toggle[aria-expanded="true"]')
        .forEach((b) => b.setAttribute("aria-expanded", "false"))

      // Toggle current.
      if (!isOpen) {
        answer.classList.add("open")
        if (chevron) chevron.classList.add("rotated")
        button.setAttribute("aria-expanded", "true")
      }
    })
  })
}
